import React from 'react';
import  {IndexLink,Link} from 'react-router';
import {isMobile} from 'react-device-detect';

const FooterComponent = () => (
  <footer>
  {isMobile != 1?
    <div className="splash_footer">
        <div className="wrapper" >
            <p className="splash_footer_logo">Versity &copy; 2025</p>
            <ul className="splash_nav">
                <li><a href="javascript:window.location.replace('/company/130098')">About</a></li>
				<li><Link to="/business" >Business</Link></li>
				<li><Link to="/advertise">Advertising</Link></li>
				<li><Link to="/career">Careers</Link></li>
				<li><Link to="/terms">Terms</Link></li>
				<li><Link to="/privacy">Privacy</Link></li>
				<li><Link to="/cookies">Cookies</Link></li>
				<li><a target="_blank" href="/blog/">Blog</a></li>
            </ul>
            <ul className="splash_social">
                <li>Connect and Share</li>
                <li><a href="https://www.facebook.com/VersityHQ/" target="_blank"><img alt="" src="static/img/homeimg/splash-social-fb.png" /></a></li>
                <li><a href="https://twitter.com/versityhq" target="_blank"><img alt="" src="static/img/homeimg/splash-social-tt.png" /></a></li>
                <li><a href="https://www.instagram.com/versityhq/" target="_blank"><img alt="" src="static/img/homeimg/splash-social-tb.png"/></a></li>
            </ul>
        </div>
    </div>	
  :
  <div className="footer-mobile">
	Versity &copy; 2025
  </div>}
</footer>
);

export default FooterComponent;


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/footer.js
 **/